import VuexPersist from 'vuex-persist'

export default new VuexPersist({
  key: 'vuex',
  storage: window.localStorage,
  reducer: state => ({ auth: state.auth })
})
